import React, { InputHTMLAttributes, forwardRef, useId } from 'react';

import { CheckedType } from '../fm-button-radio/fm-radio-button/fm-radio-button';

import './fm-checkbox-input.scss';

interface FMCheckboxInputProps
    extends Omit<
        InputHTMLAttributes<HTMLInputElement>,
        'type' | 'checked' | 'value'
    > {
    label: React.ReactNode;
    className?: string;
    checked?: CheckedType;
    value: string | number;
    hideLabel?: boolean;
    labelClassName?: string;
    wrapperClassName?: string;
    error?: boolean;
}

function getCheckedValue(checked?: CheckedType, value?: string | number) {
    if (typeof checked === 'boolean') {
        return checked;
    } else if (['string', 'number'].includes(typeof checked)) {
        return checked == value;
    }
    return undefined;
}

const FMCheckboxInput = forwardRef<HTMLInputElement, FMCheckboxInputProps>(
    function FMCheckboxInput(
        {
            label,
            className,
            checked,
            hideLabel,
            id: inputId,
            value,
            disabled,
            labelClassName,
            wrapperClassName,
            error,
            ...props
        },
        ref
    ) {
        const checkboxInputId = useId();
        const id = inputId ?? `fm-checkbox-${checkboxInputId}`;
        const checkedValue = getCheckedValue(checked, value);
        return (
            <label
                className={`fm-checkbox__wrapper ${wrapperClassName ?? ''}`}
                {...(disabled ? { 'aria-disabled': 'true' } : {})}
                htmlFor={id}
            >
                <input
                    {...props}
                    ref={ref}
                    value={value}
                    disabled={disabled}
                    id={id}
                    type="checkbox"
                    {...(typeof checkedValue !== 'undefined'
                        ? { checked: checkedValue }
                        : {})}
                    className={`fm-checkbox__input ${className ?? ''} ${
                        error ? 'error' : ''
                    }`}
                />
                <span
                    className={`fm-checkbox__label ${labelClassName ?? ''}`}
                    {...(disabled ? { 'aria-disabled': 'true' } : {})}
                    data-lablehidden={hideLabel}
                >
                    {label}
                </span>
            </label>
        );
    }
);

FMCheckboxInput.displayName = 'FMCheckboxInput';

export default FMCheckboxInput;
